const notImplementedFunc = () => Promise.reject("Not implemented");
export default notImplementedFunc;
//# sourceMappingURL=notImplementedFunc.js.map